import { get, set } from 'idb-keyval'
import type { KeptMap } from './types'

const CACHE = 'wf-v5-atlas-pictures'
const MAX_AGE = 48 * 3_600_000
const prepared: Record<string, KeptMap & { url: string }> = {}

/** Opportunistic first-commit preview; Radar owns the normal post-commit cache read. */
export async function primePicture(key: string): Promise<void> {
  if (prepared[key]) return
  const picture = await readPicture(key)
  if (!picture || prepared[key]) return
  const url = URL.createObjectURL(picture.blob), image = new Image()
  image.src = url
  try { await image.decode() } catch { URL.revokeObjectURL(url); return }
  if (document.documentElement.hasAttribute('data-booted')) { URL.revokeObjectURL(url); return }
  prepared[key] = { ...picture, url }
}
export function takePictures(): Record<string, KeptMap & { url: string }> {
  return { ...prepared }
}
/** Claim after commit: React may call an initializer twice in Strict Mode. */
export function consumePictures(): void {
  for (const key of Object.keys(prepared)) delete prepared[key]
}
/** Eight bounded last-good views. No upstream tile cache is presented as an offline map. */
export async function readPicture(key: string): Promise<KeptMap | undefined> {
  try {
    const entries = await get<KeptMap[]>(CACHE)
    return entries?.find(p => p.key === key && Date.now() - p.captured <= MAX_AGE && p.blob instanceof Blob && ['observed', 'forecast', 'terrain'].includes(p.kind))
  } catch { return undefined }
}
export async function keepPicture(picture: KeptMap): Promise<void> {
  try {
    const entries = await get<KeptMap[]>(CACHE) ?? []
    await set(CACHE, [picture, ...entries.filter(p => p.key !== picture.key && Date.now() - p.captured <= MAX_AGE)].slice(0, 8))
  } catch { /* Memory-only still works when storage is unavailable. */ }
}
